import Select from "../select/select.vue";
export default {
    data() {
        return {
			arr:[],
			activeName:[]
		};
    },
	watch:{
		sections(){
			this.again()
			return this.arr = this.sections
		}
	},
	mounted(){
		// console.log(this.sections,'-----------------------------------------------')
		
		this.again()
	},
    methods: {
		//加入购物车
		// addShoppingCart(id) {
  //           if (this.verifyLogin()) {
  //               // 没有登录, 跳转弹窗登录框
  //               this.$router.push({
  //                   path: "/personalcenter"
  //               });
  //               return;
  //           }

		// 	this.$alert('是否确定加入购物车', '加入购物车', {
		// 		confirmButtonText: '确定',
		// 		callback: action => {
		// 			this.$post('shopping_cart/search', {
		// 				token: this.$store.state.id,
		// 				offset: '0',
		// 				length: '999',
		// 				shop_id: this.$store.state.store.id,
		// 			}).then(res => {
		// 				let arr = [];
		// 				for (let val of res.data.result.data) {
		// 					arr.push(Number.parseInt(val.category_id));
		// 				}
		// 				return arr;
		// 			}).then(arr => {
		// 				if (arr.indexOf(Number.parseInt(id)) == -1) {
		// 					this.$post('shopping_cart/create', {
		// 						category_id: id,
		// 						token: this.$store.state.id,
		// 						shop_id: this.$store.state.store.id
		// 					}).then(res => {
		// 						if (res.data.status == 'success') {
		// 							this.$message({
		// 								message: '添加成功',
		// 								type: 'success'
		// 							});
		// 						}
		// 					});
		// 				} else {
		// 					this.$message({
		// 						message: '购物车内已存在商品',
		// 						type: 'error'
		// 					});
		// 				}
		// 			})
		// 		}
		// 	});
		
		
		// },
		again(){
			this.arr = this.sections
			for(let i = 0 ; i < this.arr.length ; i++){
				let str = 'row' + i
				this.activeName.push(str)
			}
			// this.arr.map((item,index)=>{
			// 	let price = 0
			// 	item.product_category_mapping.map((item1,index1)=>{
			// 		price += Number.parseFloat(item1.product_price);
			// 	})
			// 	item.price = price
			// })
			console.log(this.arr,'--------------------------------')
		},
		change(active){
			console.log(active)
		},
        //点击课程跳转到课程详情
        toSection(id) {
            let address = this.$router.resolve({
                path: '/classdetails',
                query: {
                    id: id,
                    isPay: 'false'
                }
            });
            window.open(address.href, "_blank");
            // if (this.$store.state.id) {
            //     //如果登录则再判断是否已经购买该课程
            //     this.$post('users/isPay', { product_id: id, token: this.$store.state.id }).then(res => {
            //         let query = {
            //             id: id,
            //             category_id: category_id
            //         }

            //         // 返回true则没有购买，返回一个数组就说明已经购买
            //         // 若已经购买课程则跳转学习页面，若没有则跳转详情页面
            //         if (res.data.result != true && is_project == 0) {
            //             query.purchased_id = res.data.result[0].purchased_id;
            //             query.isPay = 'true';
            //         } else {
            //             query.isPay = 'false';
            //         }
            //         let address = this.$router.resolve({
            //             path: '/classdetails',
            //             query: query
            //         });
            //         window.open(address.href, "_blank");
            //     })
            // } else {
            //     //如果没有登录则跳转课程详情
            //     let address = this.$router.resolve({
            //         path: '/classdetails',
            //         query: {
            //             id: id,
            //             category_id: category_id,
            //             isPay: 'false'
            //         }
            //     });
            //     window.open(address.href, "_blank");

            // }
        },

        // 购买套餐
        buy(categoryId, price) {
            // 1. 验证用户是否登录
            if (this.verifyLogin()) {
                // 没有登录, 跳转弹窗登录框
                this.$router.push({
                    path: "/personalcenter"
                });
                return;
            }

            // 2. 验证用户是否已购买该套餐
            // 请求用户state 为 2 的订单数据
            this.$post('orders/paid_order', {
                token: this.$store.state.id,
                offset: 0,
                length: 999
            }).then(res => {
                let list = res.data.result.data.map(item => item.id);

                // 发送订单数组和课程包id查出关联数据
                this.$post('category_order/search', {
                    category_ids: JSON.stringify([categoryId]),
                    order_ids: JSON.stringify(list),
                    offset: 0,
                    length: 999
                }).then(res2 => {
                    let list2 = res2.data.result.data;

                    if (list2.length === 0) {
                        // 用户没有购买过这个课程包
                        this.$router.push({
                            path: "/pay",
                            query: {
                                commodityList: JSON.stringify([categoryId])
                                // totalprices: price,
                                // categoryId: categoryId
                            }
                        });
                    } else {
                        this.$message.success(
                            "您已经购买了该套餐, 快去个人中心查看吧!"
                        );
                    }
                });
            });
        },

        // 验证用户是否登录
        verifyLogin() {
            return this.$isAbnormal(this.$store.state.id);
        },

        // 验证用户是否已经购买该套餐
        async verifyIsBuy(categoryId) {
            let res = await this.$post("orders/search_category", {
                token: this.$store.state.id,
                category_id: categoryId,
                state: 2
            });

            if (this.$isAbnormal(res.data.result)) {
                return false;
            } else {
                return true;
            }
        },

        // 取出数组中的productId, 返回productId数组
        getProductList(list) {
            return list.map(item => item.product_id);
        }
    },
    computed: {
        price() {
            let price = 0;
            // this.course.product_category_mapping.map(item => {
            //     price += Number.parseFloat(item.product_price);
            // });
            return price;
        }
    },
    props: {
        course: Object,
		sections: Array
    },
    components: {
        SelectLeft: Select
    },
	
};
